<template>
  <pf-card v-if="transfers.length > 0" v-for="tbd in transfers" :key="tbd.dominio" :ouia-id="`transfers-card-${tbd.dominio}`">
    <pf-card-header>
      <pf-card-title>
        <pf-title h="3">{{ $t('Trasferimenti in corso per il dominio {0}', [tbd.dominio]) }}</pf-title>
      </pf-card-title>
    </pf-card-header>
    <pf-card-body>
      <pf-data-list>
        <pf-data-list-item v-for="t in tbd.transfers" :key="t.id" :expandable="needsData(t)">
          <pf-data-list-cell>
            {{ transferTitle(t) }}
          </pf-data-list-cell>
          <pf-data-list-cell no-fill v-if="t.date && scheduled(t)">
            <pf-content>{{ $t('Pianificato per il {0}', [new Date(t.date).toLocaleDateString()]) }}</pf-content>
          </pf-data-list-cell>
          <pf-data-list-action>
            <transfer-label :transfer="t" />
          </pf-data-list-action>

          <pf-data-list-content v-if="needsData(t)">
            <form-domain-registrant
              v-if="t.type === 'domain'"
              :transfer="t"
              @submit="emit('update')"
            />
            <form-hosting-transfer
              v-else
              :transfer="t"
              @submit="emit('update')"
            />
          </pf-data-list-content>
        </pf-data-list-item>
      </pf-data-list>
    </pf-card-body>
  </pf-card>
</template>

<script lang="ts">
export function transferTitle(transfer: Transfer) {
  switch (transfer.type) {
    case 'site':
      return _t('Trasferimento del sito');
    case 'mail':
      return _t('Trasferimento delle email');
    case 'site-mail':
      return _t('Trasferimento del sito e delle email');
    case 'domain':
      return _t('Trasferimento del dominio');
  }
}
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { $t as _t } from '@/i18n';
import { type Transfer, type Transfers } from '@/resources';
import TransferLabel from './transfer-label.vue';
import FormDomainRegistrant from '../components/form-domain-registrant.vue';
import FormHostingTransfer from '../components/form-hosting-transfer.vue';
import { useLoginStore } from '@/store/login';

import type PfCard from '@vue-patternfly/core/components/Card/Card.vue';
import type { ComponentProps } from 'vue-component-type-helpers';

type PfCardProps = ComponentProps<typeof PfCard>;

interface Props extends /* @vue-ignore */ Omit<PfCardProps, 'color'> {
  transfers: Transfers;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: 'update'): void;
}>();

const login = useLoginStore();
const canEdit = computed(() => login.grants.admin || login.grants.owner || login.grants.developer);

function needsData(transfer: Transfer) {
  return canEdit.value && (transfer.status === 'pending data' || transfer.status === 'on hold');
}

function scheduled(transfer: Transfer) {
  return transfer.status === 'scheduled' || transfer.status === 'in progress';
}
</script>
